import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(`as-goals-scored`)
}
const _hoisted_2 = { class: "as-goals-scored__head" }
const _hoisted_3 = { class: "as-history" }
const _hoisted_4 = { class: "as-history-item" }
const _hoisted_5 = { class: "as-history-item__head" }
const _hoisted_6 = { class: "as-history-item__body" }
const _hoisted_7 = { class: "as-competition" }
const _hoisted_8 = { class: "as-competition__table" }
const _hoisted_9 = { class: "as-center a" }
const _hoisted_10 = { class: "as-center a" }

import IconGoalScored from '~src/components/icons/foot_stats/IconGoalScored.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref, computed } from 'vue';
    import { getClassForItem } from '~src/helpers/footystats';

    
const __default__ = {};

interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'GoalsOverUnder',
  props: {
    match: {},
    mode: { default: 'as-win' },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

    const props = __props

    const list = [
        {
            value: '05',
            title: '0.5',
        },
        {
            value: '15',
            title: '1.5',
        },
        {
            value: '25',
            title: '2.5',
        }
    ];

    const activeTab = ref('Over')
    const setActiveTab = (tab: string) => {
        activeTab.value = tab;
    };

    const textTab = computed<string>(() => {
        return activeTab.value === 'Over' ? 'Trên' : 'Dưới';
    });

    const homeTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.home_team_last_x ?? {} as IStatsParent;
    });

    const awayTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.away_team_last_x ?? {} as IStatsParent;
    });

    const getValueWithModeTB = (mode = 'btts', mode_half = '') => {
        const home = getValueWithMode('home', mode, mode_half);
        const away = getValueWithMode('away', mode, mode_half);

        return (home + away) / 2;
    }

    const getValueWithMode = (team = 'home', mode = 'btts', mode_half = '') => {
        const __data: IStatsParent = team === 'home' ? homeTeamLastX.value : awayTeamLastX.value;
        let __mode = mode
        if(mode_half){
            __mode = mode_half
        }
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
            return 0;
        }

        return __data.stats[__mode] as number;
    }

    const calculatorAVG = (home: number, away: number) => {
        const _avg = (home + away) / 2;

        return Math.round(_avg);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconGoalScored, { fill: '#FFDD00' }),
      _cache[2] || (_cache[2] = _createElementVNode("span", null, " Trên/Dưới bàn thắng ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", {
                        'as-active' : activeTab.value === 'Over'
                    }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('Over')))
          }, " Trên ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", {
                        'as-active' : activeTab.value === 'Under'
                    }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('Under')))
          }, " Dưới ", 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("th", null, "Tổng số BT", -1)),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.footyStats?.home_name), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.footyStats?.away_name), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(textTab.value) + " 0.5", 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `season${activeTab.value}05Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithMode('home', `season${activeTab.value}05Percentage_overall`)) + "% ", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `season${activeTab.value}05Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithMode('away', `season${activeTab.value}05Percentage_overall`)) + "% ", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithModeTB(`season${activeTab.value}05Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithModeTB(`season${activeTab.value}05Percentage_overall`)) + "% ", 3)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(textTab.value) + " 1.5", 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `season${activeTab.value}15Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithMode('home', `season${activeTab.value}15Percentage_overall`)) + "% ", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `season${activeTab.value}15Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithMode('away', `season${activeTab.value}15Percentage_overall`)) + "% ", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithModeTB(`season${activeTab.value}15Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithModeTB(`season${activeTab.value}15Percentage_overall`)) + "% ", 3)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(textTab.value) + " 2.5", 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `season${activeTab.value}25Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithMode('home', `season${activeTab.value}25Percentage_overall`)) + "% ", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `season${activeTab.value}25Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithMode('away', `season${activeTab.value}25Percentage_overall`)) + "% ", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithModeTB(`season${activeTab.value}25Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithModeTB(`season${activeTab.value}25Percentage_overall`)) + "% ", 3)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(textTab.value) + " 3.5", 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `season${activeTab.value}35Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithMode('home', `season${activeTab.value}35Percentage_overall`)) + "% ", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `season${activeTab.value}35Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithMode('away', `season${activeTab.value}35Percentage_overall`)) + "% ", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithModeTB(`season${activeTab.value}35Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithModeTB(`season${activeTab.value}35Percentage_overall`)) + "% ", 3)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(textTab.value) + " 4.5", 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `season${activeTab.value}45Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithMode('home', `season${activeTab.value}45Percentage_overall`)) + "% ", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `season${activeTab.value}45Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithMode('away', `season${activeTab.value}45Percentage_overall`)) + "% ", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithModeTB(`season${activeTab.value}45Percentage_overall`))}`)
                  }, _toDisplayString(getValueWithModeTB(`season${activeTab.value}45Percentage_overall`)) + "% ", 3)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})